<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-stack position-left"></i>
            <span class="text-semibold">Equbs</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <a [routerLink]="['/ekubadd']" type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-add position-left"></i> Add Equb</a>
            <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-left:30px;">
      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: </span>
        <select name="status" required [(ngModel)]="filter" (ngModelChange)="getEkubFilter(filter)"
          class="form-control">
          <option selected disabled>Status</option>
          <option value="">All</option>
          <option value="&status=pending">Pending</option>
          <option value="&status=active">Active</option>
          <option value="&status=completed">Completed</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div>

    <div class="panel-body">
      <table class="table table-striped datatable-column-search-inputs">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Bank</th>
            <th>Starting</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Threashold</th>
            <th>Ratio</th>
            <th>Length</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let ekub of ekubs | paginate: { id: 'ekubs',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">

            <td>
              <div class="media-left">
                <a href="" [routerLink]="['/ekub',ekub.id]">{{ekub.ekub_id}}
                  <div class="text-muted text-size-small">
                    {{ekub?.value|number:'1.2-2'}} ETB - {{ekub?.total_due|number:'1.2-2'}} ETB - {{ekub?.category.data.interval}}
                  </div>
                </a>
              </div>
            </td>
            <td>
              <div class="media-left">
                <span>
                  <a href="" [routerLink]="['/draw']" [queryParams]="{'id':ekub.id}"> {{ekub.category.data.title}}</a>
                  <div class="text-muted text-size-small">
                    {{ekub.category.data.amount|number:'1.2-2'}} ETB - {{ekub.category.data.interval}}
                  </div>
                </span>
              </div>

            </td>
            <!-- <td>{{ekub.posted_date|date:short}}</td> -->
            <td>
              <div class="media-left">
                <a href="" [routerLink]="['/accounts']">{{ekub?.account?.data.accronym| uppercase}}
                  <div class="text-muted text-size-small">
                    {{ekub?.account?.data.account_number}}
                  </div>
                </a>
              </div>
            </td>
            <td>
              <div class="media-left">
                <span>On {{ekub?.first_award_on}}
                  <div class="text-muted text-size-small">
                    {{ekub?.first_awards}} ekubs
                  </div>
                </span>
              </div>
            </td>
            <td>{{ekub.start_date|date:short}}</td>
            <td>{{ekub.end_date|date:short}}</td>
            <td>{{ekub.qualification_threshold}}</td>
            <td>{{ekub.registered}} / {{ekub.total_members}} - {{ekub.ratio}}%</td>
            <td>{{ekub.length}} {{mainService.getIntervalFormalStr(ekub?.category.data.interval)}}</td>
            <td>
              <span class="label label-block label-default"
                *ngIf="ekub.status === 'Pending' || ekub.status === 'pending'">{{ekub.status}}</span>
              <span class="label label-block label-primary"
                *ngIf="ekub.status === 'Active' || ekub.status === 'active'">{{ekub.status}}</span>
              <span class="label label-block bg-royal-400"
                *ngIf="ekub.status === 'completed' || ekub.status === 'completed'">{{ekub.status}}</span>
            </td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a href="" [routerLink]="['/ekubadd']" [queryParams]="{'id':ekub.id}">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li>
                      <a href="">
                        <i class="icon-file-excel"></i>Delete</a>
                    </li>
                    <li class="dropdown-submenu dropdown-submenu-left">
                      <a href="javascript:void(0);">Change Status</a>
                      <ul class="dropdown-menu">
                        <li>
                          <a (click)="changeStatus(ekub.id,'pending')">
                            <i class="icon-shuffle"></i> Pending</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(ekub.id,'active')">
                            <i class="icon-shuffle"></i> Active</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(ekub.id,'completed')">
                            <i class="icon-shuffle"></i> Completed</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="ekubs.length <=0">
            <td colspan="13" class="text-center"> <i class="icon-info22">&nbsp;</i>No Equbs yet!</td>
          </tr>
        </tbody>
      </table>

      <br>

      <div class="row">
        <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
        <div class="text-center">

          <pagination-controls id="ekubs" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>

          <br>
        </div>

      </div>


    </div>
  </div>
</div>